<template>
  <ul>
    <li v-for="(s, key, index) in schema" :key="index">
      <component
        :key="index"
        :is="typeToComponent[s.type]"
        v-model="value[key]"
        v-bind="s"
        :schema="s"
      >
        <schema-template v-if="s.child" :schema="s.child" :value="value[key]"></schema-template>
      </component>
    </li>
  </ul>
</template>

<script>
import typeToComponent from "@/config/schema-template";

export default {
  name: "SchemaTemplate",

  provide() {
    return {
      mode: this,
    };
  },
  props: {
    schema: {
      type: Object,
      default: () => {},
    },
    value: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      typeToComponent,
    };
  },
  created() {
    setTimeout(() => {
      console.log("schema", this.schema);
      console.log("value", this.value);
    }, 300);
  },
};
</script>
